import { LightUserModel } from '../../../shared/data/models/light-user.model';
import { RecepientDataModel } from '../../../shared/data/models/recepient-data.model';

export interface MessageState {
  ID: string;
  body: string;
  creationTime: number;

  user: LightUserModel;
  recepientData: RecepientDataModel;
}

export const initialMessageState: MessageState = {
  ID: null,
  body: null,
  recepientData: null,
  user: null,
  creationTime: null
};
